
import Vue from "vue";
import { FTextField, FTextareaField, FRadioGroup, FRadioGroupField } from "@fkui/vue";
import { mapFields } from "vuex-map-fields";
import AnonymMessageBox from "./AnonymMessageBox.vue";
import { Anonym } from "@/store/types";
export default Vue.extend({
    name: "AnonymFieldGroup",
    components: {
        AnonymMessageBox,
        FTextField,
        FTextareaField,
        FRadioGroup,
        FRadioGroupField,
    },
    data: () => ({
        Anonym,
    }),
    computed: {
        ...mapFields([
            "kontaktuppgifter.villDuVaraAnonym",
            "kontaktuppgifter.anmalareDittFornamn",
            "kontaktuppgifter.anmalareDittEfternamn",
            "kontaktuppgifter.anmalareKontaktuppgift",
            "kontaktuppgifter.anmalareRelationTill",
        ]),
    },
});
